"use client";

import ErrorPage from "@containers/ErrorPage";
import { ReactNode, useCallback } from "react";
import { ErrorBoundary, type FallbackProps } from "react-error-boundary";

type SiteErrorBoundaryClientProps = {
  children: ReactNode;
  errorCode: number;
};

const SiteErrorBoundaryClient = ({ children, errorCode }: SiteErrorBoundaryClientProps) => {
  const renderErrorFallback = useCallback(
    ({ error }: FallbackProps) => {
      if ((error as { digest?: string })?.digest === "NEXT_NOT_FOUND") {
        throw error;
      }

      return <ErrorPage errorCode={errorCode} />;
    },
    [errorCode],
  );

  return <ErrorBoundary fallbackRender={renderErrorFallback}>{children}</ErrorBoundary>;
};

export default SiteErrorBoundaryClient;
